// src/pages/Benefits/BenefitsPageStyles.ts
const styles = {
  BenefitsContainer: {
    backgroundColor: '#f5f7fa',
  },
  BenefitsContent: {
    padding: '24px',
  },
  addButton: {
    marginBottom: '16px',
    backgroundColor: '#5958e1',
    '&:hover': {
      backgroundColor: '#5958c0',
    },
  },
};

export default styles;
